import { Skeleton } from "@mui/material";
import { useState } from "react";
import { useSelector } from "react-redux";

import { t } from "../../translations";
import { todayDate } from "../functions/dateFunctions";
import "../styles/section-food.css";
import ChefCard from "./chef-card";

import { FaSearch } from "react-icons/fa";

const SectionFood = (props) => {
  const [selected, setSelected] = useState("discover-chefs");
  const [selectedFilter] = useState([]);

  const { setChef, searched, list, lang, load, onTabChange } = props;

  let selectedWhen = useSelector((state) => state.selectedWhen);
  let preferred = useSelector((state) => state.preferred);

  // Filter the list based on all criteria
  const filteredList =
    list
      ?.filter((item) => {
        if (selectedFilter.length === 0) {
          return item;
        }
        return item;
      })
      ?.filter((item) => {
        if (searched.length > 0) {
          return (item?.firstname + " " + item.lastname)
            ?.toLowerCase()
            .includes(searched.toLowerCase());
        }
        return item;
      })
      ?.filter((item) => {
        if (selected === "preferred") {
          return preferred.includes(item?._id);
        }
        if (selected === "discover-chefs") {
          return item?.chef === true;
        }
        if (selected === "discover-restaurants") {
          return item?.restaurant === true;
        }
        return item;
      })
      ?.filter((item) => {
        // Exclude chefs from results when today is selected
        const today = todayDate();
        if (
          selected === "discover-chefs" &&
          selectedWhen === today &&
          item?.chef === true
        ) {
          return false;
        }
        return true;
      }) || [];

  // Determine empty state message based on selected tab
  const getEmptyMessage = () => {
    if (list.length === 0) {
      return t("section_food.coming_soon", lang);
    }
    if (selected === "discover-chefs") {
      return t("section_food.no_chefs_found", lang);
    }
    if (selected === "discover-restaurants") {
      return t("section_food.no_restaurants_found", lang);
    }
    if (selected === "preferred") {
      return t("section_food.no_favorites_found", lang);
    }
    return t("section_food.coming_soon", lang);
  };

  const renderLoadingSkeleton = () => (
    <div
      style={{
        width: "100%"
      }}
    >
      {[0, 1, 2, 3, 4, 5, 6].map((item) => (
        <Skeleton
          key={item}
          variant="text"
          sx={{ fontSize: "1rem", height: 80 }}
        />
      ))}
    </div>
  );

  const populateFood = () => {
    if (filteredList.length === 0) {
      return (
        <div
          style={{
            width: "100%",
            height: 500,
            display: "flex",
            flexDirection: "column",
            alignItems: "center"
          }}
        >
          <FaSearch
            size={40}
            color={"gray"}
            style={{
              marginTop: 60
            }}
          />
          <p
            style={{
              marginTop: 20,
              fontSize: 20
            }}
          >
            {getEmptyMessage()}
          </p>
        </div>
      );
    } else {
      return filteredList.map((chef) => (
        <ChefCard
          key={chef._id || chef.id}
          chef={chef}
          selectedWhen={selectedWhen}
          setChef={setChef}
        />
      ));
    }
  };

  return (
    <div className="section-food-principal">
      <div className="menu-line">
        {[
          {
            key: "discover-chefs",
            text: t("navigation.discover_chefs", lang, false)
          },
          {
            key: "discover-restaurants",
            text: t("navigation.discover_restaurants", lang, false)
          },
          {
            key: "preferred",
            text: t("navigation.my_favourites", lang)
          }
        ].map((item) => (
          <span
            className={selected === item?.key ? "active" : ""}
            key={item.key}
            onClick={() => {
              setSelected(item?.key);
              if (onTabChange) {
                onTabChange(item?.key);
              }
            }}
          >
            {item.text}
          </span>
        ))}
      </div>

      <div className="section-princ">
        <div className="display-chef">
          <div className="section-food">
            {load ? renderLoadingSkeleton() : populateFood()}
          </div>
        </div>
      </div>
    </div>
  );
};

export default SectionFood;
